import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputRightAddon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Stack,
} from '@chakra-ui/react';
import { FaChevronDown } from 'react-icons/fa6';
import type { CashbackPaymentStatusFilter } from 'services/interfaces/cashback';

export interface CashbackFiltersValues {
  status: CashbackPaymentStatusFilter;
  search: string;
  startDate: string;
  endDate: string;
}

interface CashbackFiltersProps {
  values: CashbackFiltersValues;
  onChange: (patch: Partial<CashbackFiltersValues>) => void;
  disabled?: boolean;
}

const CashbackFilters: React.FC<CashbackFiltersProps> = ({
  values,
  onChange,
  disabled,
}) => {
  const isIdiMode = values.search.startsWith('idi:');

  const toggleIDISearch = (useIdi: boolean) => {
    let next = values.search;
    if (!useIdi && next.startsWith('idi:')) {
      next = next.slice(4);
    } else if (useIdi && !next.startsWith('idi:')) {
      next = `idi:${next}`;
    }
    onChange({ search: next });
  };

  return (
    <Stack
      direction={{ base: 'column', md: 'row' }}
      flexWrap="wrap"
      gap={{ base: 3, md: 4 }}
      align={{ md: 'flex-end' }}
    >
      <FormControl maxW={{ md: '200px' }}>
        <FormLabel fontSize="sm" mb={1}>
          Status
        </FormLabel>
        <Select
          size="sm"
          value={values.status}
          isDisabled={disabled}
          onChange={(e) =>
            onChange({
              status: e.target.value as CashbackPaymentStatusFilter,
            })
          }
        >
          <option value="">Todos</option>
          <option value="paid">Pago</option>
          <option value="unpaid">Pendente</option>
        </Select>
      </FormControl>

      <FormControl flex="1" minW={{ md: '240px' }}>
        <FormLabel fontSize="sm" mb={1}>
          Buscar
        </FormLabel>
        <InputGroup size="sm">
          <Input
            placeholder={
              isIdiMode
                ? 'Digite o IDI da instalação…'
                : 'Empresa, documento ou chave Pix…'
            }
            value={isIdiMode ? values.search.slice(4) : values.search}
            isDisabled={disabled}
            onChange={(e) => {
              const raw = e.target.value;
              onChange({ search: isIdiMode ? `idi:${raw}` : raw });
            }}
          />
          <InputRightAddon p="0">
            <Menu>
              <MenuButton
                as={Button}
                rightIcon={<FaChevronDown />}
                size="sm"
                rounded="0 5px 5px 0"
                h="100%"
                minW="90px"
              >
                {isIdiMode ? 'IDI' : 'Geral'}
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => toggleIDISearch(false)}>
                  Geral
                </MenuItem>
                <MenuItem onClick={() => toggleIDISearch(true)}>
                  Apenas IDI
                </MenuItem>
              </MenuList>
            </Menu>
          </InputRightAddon>
        </InputGroup>
      </FormControl>

      <HStack spacing={3} flexWrap="wrap">
        <FormControl w={{ base: '100%', md: '160px' }}>
          <FormLabel fontSize="sm" mb={1}>
            Solicitação de
          </FormLabel>
          <Input
            type="date"
            size="sm"
            value={values.startDate}
            isDisabled={disabled}
            onChange={(e) => onChange({ startDate: e.target.value })}
          />
        </FormControl>
        <FormControl w={{ base: '100%', md: '160px' }}>
          <FormLabel fontSize="sm" mb={1}>
            Solicitação até
          </FormLabel>
          <Input
            type="date"
            size="sm"
            value={values.endDate}
            isDisabled={disabled}
            onChange={(e) => onChange({ endDate: e.target.value })}
          />
        </FormControl>
      </HStack>
    </Stack>
  );
};

export default CashbackFilters;
